import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ClickCorrelationService } from '../services/click-correlation.service';

@Injectable()
export class ClickCorrelationInterceptor implements HttpInterceptor {
  constructor(private correlationService: ClickCorrelationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const id = this.correlationService.claimNext();
    if (!id) {
      return next.handle(req);
    }
    return next
      .handle(req)
      .pipe(finalize(() => {
        setTimeout(() => this.correlationService.markComplete(id), 100)
      }));
  }
}

export const ClickCorrelationInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ClickCorrelationInterceptor,
  multi: true,
};
